define(['underscore', 'edge/platform/base/BaseCtrl'], (_, BaseCtrl)=> {
    const fn = (LocaleService, $filter, $scope, $anchorScroll, StateUtils, LoadSaveService, MVRClueService, $window, submissionViewModel, $state, ModalService, InMemorySession, $q, ErrorHandlingService, ViewModelService, ViewModelContext)=> {
        const ctrl = Object.create(BaseCtrl);
        const flowModel = StateUtils.activeDataForState(true).flowModel;
        const submissionVM = submissionViewModel();
        var vehicles;
        var drivers;
        var doReQuoteOnFail;

        ctrl.init = ()=> {
            $anchorScroll();
            $scope.page = {
                sessionUUID: submissionVM.sessionUUID.value,
                quoteID: submissionVM.quoteID.value,
                productCode : submissionVM.value.draftData.productCode
            };

            processMVRClue();

        };

        var requotedDataOnSuccess = function(){

                                const quoting = submissionVM.quoteData.value;
                                //$scope.page.standardQuotes = _.where(quoting.offeredQuotes, {branchCode: "StandardProgram"});
                                if(submissionVM.value.draftData.productCode == "PersonalAuto"){
                                 //$scope.page.standardQuotes = _.where(requotedOffers, {branchCode: "StandardProgram"});
                                   $scope.page.standardQuotes = [];
                                }else{
                                   $scope.page.standardQuotes = _.where(quoting.offeredQuotes,{isCustom: false});
                                }
                                $scope.page.customQuotes = _.where(quoting.offeredQuotes, {isCustom: true});
                                $scope.page.offeringLabels = ctrl._setOfferingLabels($scope.page.standardQuotes);
                                $scope.page.baseOffering = ctrl._setBaseOffering($scope.page.standardQuotes);
                                if(submissionVM.value.draftData.productCode === "PersonalAuto") {
                                    vehicles = submissionVM.draftData.lobs.personalAuto.value.vehicles;
                                    var message = '';
                                            for(var i in vehicles){
                                               message = message + ErrorHandlingService.getVehicleAgeValidated(vehicles[i], $scope.page.customQuotes);
                                            }
                                            if(message != ''){
                                                         ModalService.showError('quoteandbind.controllers.QuoteDetails.Attention',
                                                                                   message).result;
                                            }
                                    drivers = submissionVM.draftData.lobs.personalAuto.value.drivers;
                                    for (x in $scope.page.offeringLabels) {
                                        if ("Best Value" == $scope.page.offeringLabels[x]) {
                                            $scope.tabSelected = parseInt(x) + 1;
                                        }
                                    }
                                    //TODO: get BI Limits from Submission VM
                                    if (submissionVM.draftData.lobs.personalAuto.prevCarrierInfo.priorBILimits) {
                                        $scope.biLimits = submissionVM.draftData.lobs.personalAuto.prevCarrierInfo.priorBILimits.value;
                                    } else {
                                        if(InMemorySession.getBiLimits() != undefined)
                                        $scope.biLimits = InMemorySession.getBiLimits().name;
                                    }
                                }
                };


        ctrl.printQuote = ()=> {
            $window.print();
        };

        ctrl.setSelectedQuote = (quote)=> {
            if (quote.branchCode === 'CUSTOM' || quote.branchCode.indexOf('Version') === 0) {
                $scope.$broadcast('CustomQuoteSelected', [quote.publicID]);
            }
        };

        ctrl.getCustomQuoteHeaderCostString = ()=> {
            return `${LocaleService.getLocaleInfo().currency.symbol}0.00`;
        };

        var jobDetails ={
            jobNumber : submissionVM.quoteID.value
        }

        ctrl.buy = (selectedQuote, numberOfPayments)=> {
             StateUtils.activeDataForState(true).numberOfPayments = numberOfPayments;
             StateUtils.activeDataForState(true).chosenQuote = selectedQuote.publicID;
             submissionVM.value.bindData.chosenQuote = selectedQuote.publicID;
             var saveQuotedSubmission = LoadSaveService.saveQuotedSubmission(null, submissionVM.value);
              ModalService.showProgressDialog('quoteandbind.controllers.Please wait', saveQuotedSubmission);
             saveQuotedSubmission.then(function(response){
                var submissionModel = ViewModelService.create(response, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', ViewModelContext)
                flowModel.next(submissionModel);
             },function(error){
                 $state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null});
             })

        };

        var processMVRClue = function(){
            var response =  MVRClueService.orderMVRClue(jobDetails);
            ModalService.showProgressDialog('quoteandbind.controllers.Please wait', response);
            return response.then(function(mvrDataResponse){
                 getSubmission();
            },function(error){
                 getSubmission();
            });
        }



       var getSubmission = function(selectedQuote, numberOfPayments){
            var submissionDTO = {
                postalCode: submissionVM,
                quoteID: submissionVM.quoteID.value
            }

           var requotedData =  LoadSaveService.saveAndQuoteSubmission(null,submissionVM.value)
           ModalService.showProgressDialog('quoteandbind.controllers.Please wait', requotedData);
           return requotedData.then(function(reQuotedResponse){
                var premiumChangedFlag = 0;
                var coveragesChanged = false;
                doReQuoteOnFail = false;
                var requotedOffers = reQuotedResponse.quoteData.offeredQuotes;
                var quotedOffers  = submissionVM.quoteData.offeredQuotes.value;
                for(var x in requotedOffers){
                   if(requotedOffers[x].branchCode == "CUSTOM" ) {
                      for(var vehicleCov in requotedOffers[x].lobs.personalAuto.vehicleCoverages){
                          if(requotedOffers[x].lobs.personalAuto.vehicleCoverages[vehicleCov].coverages.length != quotedOffers[x].lobs.personalAuto.vehicleCoverages[vehicleCov].coverages.length ){
                           if(requotedOffers[x].lobs.personalAuto.vehicleCoverages[vehicleCov].coverages.length != 0){
                                 coveragesChanged = true;
                           }

                          }
                      }

                   }
                }

                if(coveragesChanged){
                    ModalService.showCustomInfo('quoteandbind.controllers.QuoteDetails.Attention',
                                             'quoteandbind.controllers.QuoteDetails.coverages have changed').result;
                }

                submissionVM.quoteData = reQuotedResponse.quoteData;
                requotedDataOnSuccess();

            },function (error) {

                var exception = {error: error};

                 if(error.constructor == Array && error.length > 0 && error[0].baseError && error[0].baseError.data  &&
                       error[0].baseError.data.error && error[0].baseError.data.error.message != undefined ) {
                            message = error[0].baseError.data.error.message;
                 }

                  if(message && message.indexOf('coverage') > -1){
                       doReQuoteOnFail = true;
                       const quoting = submissionVM.quoteData.value;
                        if(submissionVM.value.draftData.productCode === "Homeowners") {
                                  $scope.page.standardQuotes = _.where(quoting.offeredQuotes, {isCustom: false});
                        }
                         if(submissionVM.value.draftData.productCode === "PersonalAuto"){
                            $scope.page.standardQuotes = [];
                         }
                                                 $scope.page.customQuotes = _.where(quoting.offeredQuotes, {isCustom: true});
                                                 $scope.page.offeringLabels = ctrl._setOfferingLabels($scope.page.standardQuotes);
                                                 $scope.page.baseOffering = ctrl._setBaseOffering($scope.page.standardQuotes);

                                                 $scope.page.standardQuotes = undefined;
                                                 if(submissionVM.value.draftData.productCode != "Homeowners") {

                                                   //TODO: get BI Limits from Submission VM
                                                    if (submissionVM.draftData.lobs.personalAuto.prevCarrierInfo.priorBILimits) {
                                                       $scope.biLimits = submissionVM.draftData.lobs.personalAuto.prevCarrierInfo.priorBILimits.value;
                                                    } else {
                                                       if(InMemorySession.getBiLimits() != undefined)
                                                       $scope.biLimits = InMemorySession.getBiLimits().name;
                                                     }
                                                 }

                                                goToStep = ErrorHandlingService.getQuoteExceptionHandler(exception,submissionVM);
                                                 if('error' == goToStep){
                                                    const messageHeader = $filter('translate')('integration.quoteandbind.directives.custom-quote.Invalid Coverage Option');
                                                    var errorMsg = submissionVM.draftData.lobs.value.exception
                                                    if(ErrorHandlingService.isDisplayError(errorMsg)){
                                                        ModalService.showError(messageHeader, errorMsg);
                                                    }else{
                                                         $state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null,errorMsg :submissionVM.draftData.lobs.value.exception });
                                                    }
                                                 }
                                          }else{
                                            ErrorHandlingService.getBindExceptionHandler(exception,submissionVM);
                                            $state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null,errorMsg :submissionVM.draftData.lobs.value.exception });
                                          }
               //StateUtils.activeDataForState(true).numberOfPayments = numberOfPayments;
               //StateUtils.activeDataForState(true).chosenQuote = selectedQuote.publicID;
               //flowModel.next(submissionVM);
               /*const errorPromise = ModalService.showError(
                   'quoteandbind.common.config.FlowConfig.Unable to generate a quote',
                   'quoteandbind.common.config.FlowConfig.An error occurred while attempting to calculate a quote.'
               ).result;
               errorPromise.then(function(resp) {
                   $state.go('contactUs', {quoteID: (submissionVM) ? submissionVM.quoteID.value : null});
               });*/
           });
       }


        ctrl._setOfferingLabels = (standardOfferings)=> {
            return _.map(standardOfferings, (offering)=> {
                return $filter('translate')(`quoteandbind.controllers.QuoteDetails.${offering.branchCode}`);
            });
        };

        ctrl._setBaseOffering = (standardOfferings)=> {
            if (angular.isArray(standardOfferings) && standardOfferings.length === 1) {
                return standardOfferings[0];
            } else if (angular.isArray(standardOfferings) && standardOfferings.length > 1) {
                return standardOfferings[1];
            }
        };

        return ctrl.create($scope);
    };
    fn.$inject = ['LocaleService', '$filter', '$scope', '$anchorScroll', 'StateUtils', 'qnb.LoadSaveService', 'MVRClueService','$window', 'submissionViewModel', '$state', 'ModalService', 'InMemorySession','$q', 'qnb.ErrorHandlingService', 'ViewModelService', 'qnb.ViewModelCtx'];

    return fn;
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/common/controllers/ReQuoteDetailsCtrl.js
 **/